import React from 'react'
import { Typography } from '@mui/material'
import RowStack from 'components/atoms/container/RowStack'
import colors from 'styles/colors'

const IconTextGroup = ({
  group,
  color = colors.Grey400,
  ...containerProps
}) => {
  const IconText = ({ icon, text }) => (
    <RowStack spacing={2} width={'auto'}>
      {React.cloneElement(icon, { style: { fontSize: 20 } })}
      <Typography variant='body1Small' color={color}>
        {text}
      </Typography>
    </RowStack>
  )

  return (
    <RowStack spacing={4} {...containerProps}>
      {group.map((item, index) => (
        <React.Fragment key={index}>
          <IconText icon={item.icon} text={item.text} />
          {index < group.length - 1 && (
            <Typography variant='body1' color={color}>
              •
            </Typography>
          )}
        </React.Fragment>
      ))}
    </RowStack>
  )
}

export default IconTextGroup
